export default [
    {
        title: 'Estaciones Hidrometereológicas',
        icons: [
            {src: require('@/assets/icons/despejado.svg'), title: 'Día despejado'},
            {src: require('@/assets/icons/nubladoParcial.svg'), title: 'Día parcialmente nublado'},
            {src: require('@/assets/icons/nublado.svg'), title: 'Día nublado'},
            {src: require('@/assets/icons/lluvia.svg'), title: 'Día con lluvia'},
            {src: require('@/assets/icons/nubladoNoche.svg'), title: 'Noche nublada'},
            {src: require('@/assets/icons/lluviaNoche.svg'), title: 'Noche con lluvia'},
            {src: require('@/assets/icons/comunitarias.svg'), title: 'Estaciones comunitarias'},
            {src: require('@/assets/icons/desconectadaParcial.svg'), title: 'Estación con funcionamiento parcial'},
            {src: require('@/assets/icons/desconectada.svg'), title: 'Estación temporalmente fuera de servicio'},
            {src: require('@/assets/icons/sinConexion.svg'), title: 'Estación sin conexión'}
        ]
    },
    {
        title: 'Estaciones Acelerográficas',
        icons: [
            {src: require('@/assets/icons/acelerografica.svg'), title: 'Estaciones Acelerográficas'}
        ]
    },
    {
        title: 'Estaciones Aguas Subterráneas',
        icons: [
            {src: require('@/assets/icons/aguaSubterranea.svg'), title: 'Estaciones Aguas Subterráneas'}
        ]
    },
    {
        title: 'Estaciones Calidad del Aire',
        icons: [
            {src: require('@/assets/icons/calidad_aire.svg'), title: 'Estaciones Calidad del Aire'}
        ]
    }
]